import PropTypes from 'prop-types';
import { getTenantConfig } from 'Utils';
const UIMSDKEnv = process.env.REACT_APP_UIM_SDK_ENV;
const policyBaseURL =
  UIMSDKEnv === 'design'
    ? getTenantConfig().policyBaseURL.design
    : getTenantConfig().policyBaseURL.production;

const Footer = ({ country, language, privacy, terms }) => {
  const locale = `${language}_${country}`;
  const policies = [
    {
      id: 'terms',
      string: terms,
      url: `${policyBaseURL}/terms/${locale}`,
    },
    {
      id: 'privacy',
      string: privacy,
      url: `${policyBaseURL}/privacy/${locale}`,
    },
  ];

  return (
    <div className="footer">
      {policies.map((policy) => (
        <a
          className="sublink"
          href={policy.url}
          target="_blank"
          key={policy.id}
        >
          {policy.string}
        </a>
      ))}
    </div>
  );
};

Footer.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  privacy: PropTypes.string.isRequired,
  terms: PropTypes.string.isRequired,
};

export default Footer;
